import React from "react";
import {
	ComposableMap,
	Geographies,
	Geography,
	ZoomableGroup,
} from "react-simple-maps";
import { Tooltip } from "react-tooltip";

const geoUrl = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const mapCountryData = (analyticsData) => {
	if (!Array.isArray(analyticsData)) return [];

	return analyticsData.map((item) => {
		const name = item.location || item.country || item.name || "Unknown";

		return {
			name,
			id: String(item.numId || item.id || ""),
			key: String(name).trim().toLowerCase(),
			count: Number(item.count || item.value || 0),
		};
	});
};

const WorldMap = ({ data }) => {
	const mappedData = mapCountryData(data);

	const getColor = (count) => {
		if (count > 1000) return "#7f1d1d";
		if (count > 500) return "#b91c1c";
		if (count > 250) return "#dc2626";
		if (count > 100) return "#ea580c";
		if (count > 50) return "#f59e0b";
		if (count > 10) return "#facc15";
		if (count > 1) return "#fde68a";
		if (count === 1) return "#fef3c7";
		return "#e5e7eb";
	};

	const countryById = Object.fromEntries(
		mappedData.filter((d) => d.id).map((d) => [d.id, d]),
	);
	const countryByName = Object.fromEntries(mappedData.map((d) => [d.key, d]));

	return (
		<div className="home__mapCanvas">
			<ComposableMap projectionConfig={{ scale: 155 }}>
				<ZoomableGroup zoom={1} minZoom={1} maxZoom={3} center={[0, 0]}>
					<Geographies geography={geoUrl}>
						{({ geographies }) =>
							geographies.map((geo) => {
								const geoName = geo.properties.name;
								const countryData =
									countryById[String(geo.id)] ||
									countryByName[String(geoName).trim().toLowerCase()] || {
										count: 0,
										name: geoName,
									};

								return (
									<Geography
										key={geo.rsmKey}
										geography={geo}
										fill={getColor(countryData.count)}
										stroke="#ffffff"
										strokeWidth={0.45}
										data-tooltip-id="map-tooltip"
										data-tooltip-content={`${countryData.name}: ${countryData.count}`}
										style={{
											default: { outline: "none" },
											hover: {
												fill: "#2563eb",
												stroke: "#ffffff",
												strokeWidth: 1,
												outline: "none",
											},
											pressed: { outline: "none" },
										}}
									/>
								);
							})
						}
					</Geographies>
				</ZoomableGroup>
			</ComposableMap>
			<Tooltip id="map-tooltip" />
		</div>
	);
};

export default WorldMap;
